import { render, staticRenderFns } from "./NotificationDatatable.vue?vue&type=template&id=683fcd42"
import script from "./NotificationDatatable.vue?vue&type=script&lang=js"
export * from "./NotificationDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports